import { render, staticRenderFns } from "./BlockParameter.vue?vue&type=template&id=b7329df8"
import script from "./BlockParameter.vue?vue&type=script&lang=js"
export * from "./BlockParameter.vue?vue&type=script&lang=js"
import style0 from "./BlockParameter.vue?vue&type=style&index=0&id=b7329df8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports